import * as React from 'react';

export const DropdownNoOptionsWrapper: React.FC<{ NoOptionsComponent: React.FC }> = ({ NoOptionsComponent }) => {
	return (
		<div className="flex h-full w-full items-center justify-center">
			<NoOptionsComponent />
		</div>
	);
};
